export default __webpack_public_path__ + "static/media/cart_outline_blue.cf669df1.svg";